import { useAtlasAuthContext } from "@/contexts/atlas-auth";
import { useEffectOnMount } from "@/domains/react/useEffectOnMount";

export const useLogOutPageLogic = () => {
  const { authContext } = useAtlasAuthContext();

  useEffectOnMount(() => {
    authContext.logOut();
  });
};
